<script>
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";

export default {
  name: "StoryButton",
  elementPanelSettings: {
    displayName: "Go To Story",
    elementGroup: "storyElements",
  },
  extends: BaseButtonElement,
  mixins: [StoryPageElementMixin],
  // storyHref reads this option; undeclared it resolves undefined → "#".
  options: [
    StoryCardClickBehavior,
  ],
  // An empty text-option renders caption-less outside edit mode (the label
  // routes to a slot iButton doesn't have), so a fresh drop must ship one.
  optionBundles: [
    new ButtonOptions({ "default.text-option": "Go To Story" }),
  ],
  methods: {
    handleButtonClick() {
      // `storyEntityId` honours the bound context; the hydrated row's
      // `entity.id` is empty until the fetch lands.
      const storyId = this.storyEntityId;
      if (!storyId) {
        // eslint-disable-next-line no-console
        console.error("StoryButton: no story resolved for this element — its bound context "
          + `("${this.boundContextName ?? "story"}") supplied no id, so the button has nowhere to go`);
        return;
      }
      // storyHref honours the click-behavior option and the destination's
      // nested route (entity.nestedUrl) on staging/production.
      const hydrated = Number(this.entity?.id) > 0;
      window.location.href = hydrated ? this.storyHref : `${this.links.web}/story/${storyId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
